import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const forgeFieldContextualConfigurationRoute: InvariantJiraRoute = {
	name: 'forge-spa-field-context-config',
	path: '/jira/settings/issues/field/:fieldId/context/:contextId/configure/app',
};
